import merge from 'deepmerge';
import { useMemo } from 'react';
import isEqual from 'lodash/isEqual';
import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

import { APOLLO_STATE_PROP_NAME } from '@interfaces/index';
import { createApolloClient } from '@apolloClient/createApolloClient';

let apolloClient: ApolloClient<NormalizedCacheObject>;

export default function useApollo(pageProps: { [APOLLO_STATE_PROP_NAME]: NormalizedCacheObject }) {
  const state = pageProps[APOLLO_STATE_PROP_NAME];
  return useMemo(() => {
    const _apolloClient = apolloClient ?? createApolloClient();

    if (state) {
      // Get existing cache, loaded during client side data fetching
      const existingCache = _apolloClient.extract();

      // Merge the existing cache into data passed from getStaticProps/getServerSideProps
      const data = merge(state, existingCache, {
        // combine arrays using object equality (like in sets)
        arrayMerge: (destinationArray, sourceArray) => [
          ...sourceArray,
          ...destinationArray.filter(d => sourceArray.every(s => !isEqual(d, s))),
        ],
      });

      // Restore the cache with the merged data
      _apolloClient.cache.restore(data);
    }

    return _apolloClient;
  }, [state]);
}
